import React from "react";
import "./TrackedWebsitesTabItem.less";
import { Menu, Dropdown, Button } from "antd";

const TrackedWebsitesTabItem = (props) => {
  const settingsItems = [
    { key: "competitors", path: "/dashboard/settings/competitors", title: "Competitors" },
    { key: "keywords", path: "/dashboard/settings/keywords", title: "Keywords" },
    { key: "location", path: "/dashboard/settings/location", title: "Location" },
    { key: "notifications", path: "/dashboard/settings/notifications", title: "Notifications" },
    { key: "remove-url", path: "/dashboard/settings/remove-url", title: "Remove URL" }
  ];

  const menu = (
    <Menu className="url-options">
      {settingsItems.map((item) => (
        <Menu.Item key={item.key} onClick={() => props.push(`/dashboard/settings/${item.key}`)}>
          {item.title}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className={`report-indicator ${props.status ? props.status : ""}`} data-cy="tracked-website-url">
      <div className="tab-item-content flexbox align-center">
        <div className="favicon-container">
          <img
            src={props.faviconUrl || "/images/default_favicon.png"}
            alt=""
            className={props.faviconUrl ? "" : "default"}
            onError={(e) => {
              e.target.className = "default";
              if (e.target.src !== "/images/default_favicon.png") {
                e.target.src = "/images/default_favicon.png";
              }
            }}
          />
        </div>
        {props.url}
        <Dropdown overlay={menu} placement="bottomRight">
          <Button icon="ellipsis"></Button>
        </Dropdown>
      </div>
      {props.status && <span className="tab-title-indicator" />}
    </div>
  );
};

export default TrackedWebsitesTabItem;
